var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-loader",style:({'z-index': _vm.zIndex})},[_c('div',{staticClass:"lds-ripple"},[_c('div',{style:({color: _vm.color})}),_c('div',{style:({color: _vm.color})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }